/* Heartnoks PDP — photo carousel + video carousel behaviour (preview draft 2026-09-15). */
(() => {
  // Only one video on the page may play at a time (no overlapping sound).
  document.addEventListener('play', (e) => {
    document.querySelectorAll('video').forEach((v) => { if (v !== e.target && !v.paused) v.pause(); });
  }, true);

  document.querySelectorAll('[data-hnx-carousel]').forEach((root) => {
    const track = root.querySelector('.hnx-car__track');
    const prev = root.querySelector('.hnx-car__nav--prev');
    const next = root.querySelector('.hnx-car__nav--next');
    const bar = root.querySelector('.hnx-car__progress span');
    const pageStep = () => {
      const item = track.firstElementChild;
      if (!item) return track.clientWidth;
      const unit = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      return unit * Math.max(1, Math.floor(track.clientWidth / unit));
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('is-static', max <= 2);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      bar.style.width = `${max > 2 ? ((track.scrollLeft + track.clientWidth) / track.scrollWidth) * 100 : 100}%`;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -pageStep() }));
    next.addEventListener('click', () => track.scrollBy({ left: pageStep() }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  document.querySelectorAll('[data-hnx-videos]').forEach((root) => {
    const cards = [...root.querySelectorAll('.hnx-rv__card')];
    cards.forEach((card) => {
      const v = card.querySelector('video');
      const btn = card.querySelector('.hnx-rv__play');
      btn.addEventListener('click', async () => {
        if (!v.getAttribute('src')) v.src = v.dataset.src; // poster first, video loads on demand
        v.muted = false;
        v.controls = true;
        btn.hidden = true;
        try { await v.play(); } catch (e) { /* controls stay visible so the viewer can start it */ }
      });
    });
    // A card swiped out of view, or the section scrolled past, pauses its video.
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) e.target.querySelector('video').pause();
    }), { threshold: 0.35 });
    cards.forEach((card) => io.observe(card));
    // Posters are set only when a card nears the viewport.
    const posterIo = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const v = e.target.querySelector('video');
      v.poster = v.dataset.poster;
      posterIo.unobserve(e.target);
    }), { rootMargin: '300px 0px' });
    cards.forEach((card) => posterIo.observe(card));
  });

  // Buy box quantity stepper.
  document.querySelectorAll('[data-hnb-qty]').forEach((q) => {
    const input = q.querySelector('input');
    q.querySelectorAll('[data-step]').forEach((btn) => btn.addEventListener('click', () => {
      const next = (parseInt(input.value, 10) || 1) + Number(btn.dataset.step);
      input.value = String(Math.min(Number(input.max) || 99, Math.max(Number(input.min) || 1, next)));
    }));
  });
})();


// 缩略图从 4 个变成 9 个、需要横向滚动之后，跟着主图把当前缩略图滚进可视区。
// 主题原来的 gallery JS 只切 .is-active，不管滚动位置。
(function () {
  var strip = document.querySelector('#hnx-mediator-pdp .hnx-mp__thumbnails');
  if (!strip || !window.MutationObserver) return;
  new MutationObserver(function () {
    var active = strip.querySelector('.is-active');
    if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }).observe(strip, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();
